<template>
    <div class="skeleton-photo skeleton-el">
        <div class="block1">
            <div class="left">
                <div class="block"></div>
                <div class="block"></div>
            </div>
            <div class="right block"></div>
        </div>
        <div class="block2 block"></div>
        <div class="block3 block"></div>
        <div class="block4">
            <div class="block"></div>
            <div class="block"></div>
        </div>
        <div class="block5 block"></div>
        <div class="block7">
            <div class="block"></div>
            <div class="block"></div>
        </div>
        <ul class="block8">
            <li class="block"></li>
            <li class="block"></li>
            <li class="block"></li>
            <li class="block"></li>
        </ul>
        <div class="block6">
            <div>
                <div class="block"></div>
                <div class="block"></div>
            </div>
            <div class="block"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'SkeletonPhotov2',
};
</script>
<style lang="scss" scoped>
.skeleton-photo {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    padding: 122px 30px 0;
    background: #fff;
    .block {
        background: #F0F0F0;
    }

    .block1 {
        @include SpaceBetween();
        .left div {
            height: 36px;
            border-radius: 18px;
            &:first-child {
                width: 142px;
            }
            &:last-child {
                width: 412px;
                margin-top: 17px;
            }
        }
        .right {
            width: 162px;
            height: 60px;
            margin-top: 10px;
            border-radius: 30px;
        }
    }
    .block2 {
        width: 220px;
        height: 212px;
        margin-top: 32px;
    }
    .block3 {
        width: 136px;
        height: 36px;
        border-radius: 18px;
        margin: 28px 0 26px;
    }
    .block4 {
        @include SpaceBetween();
        div {
            width: 332px;
            height: 48px;
            border-radius: 24px;
        }
    }
    .block5 {
        height: 188px;
        margin-top: 30px;
    }
    .block7 {
        @include SpaceBetween();
        align-items: center;
        margin-top: 24px;
        div:first-child {
            width: 136px;
            height: 36px;
            border-radius: 18px;
        }
        div:last-child {
            width: 140px;
            height: 56px;
            border-radius: 28px;
        }
    }
    .block8 {
        @include SpaceBetween();
        margin-top: 20px;
        li {
            width: 156px;
            height: 156px;
        }
    }
    .block6 {
        width: 100vw;
        height: 130px;
        position: fixed;
        bottom: 0;
        left: 0;
        background: #fff;
        @include SpaceBetween();
        align-items: center;
        padding: 0 30px 0 40px;
        & > div {
            &:first-child {
                @include SpaceBetween();
                div {
                    width: 100px;
                    height: 36px;
                    border-radius: 18px;
                    margin-right: 29px;
                }
            }
            &:last-child {
                width: 274px;
                height: 76px;
                border-radius: 38px;
            }
        }
    }
}
</style>
